var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertySeeDetailsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1726 1.27017L8.93696 7.66988C8.83545 7.77411 8.71293 7.85717 8.57693 7.91394C8.44094 7.97071 8.29436 8 8.14621 8C7.99806 8 7.85148 7.97071 7.71548 7.91394C7.57949 7.85717 7.45697 7.77411 7.35545 7.66988L1.11981 1.27017C0.651346 0.789239 1.00411 0 1.68795 0H14.6045C15.2883 0 15.6411 0.789239 15.1726 1.27017Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertySeeDetailsMobile);
export default __webpack_public_path__ + "static/media/Property-See-Details-Mobile.323f889d20aacadee0f3de7188ba0442.svg";
export { ForwardRef as ReactComponent };